import { render, staticRenderFns } from "./RegisterChoose.vue?vue&type=template&id=73e1f5fa"
import script from "./RegisterChoose.vue?vue&type=script&lang=js"
export * from "./RegisterChoose.vue?vue&type=script&lang=js"
import style0 from "./RegisterChoose.vue?vue&type=style&index=0&id=73e1f5fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports